import { AppDatePicker } from "../../../core/AppDatePicker";
import { differenceInDays } from 'date-fns';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { Box, FormGroup } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const validateRange = (startDate, endDate) => {
  const MAX_RANGE_IN_DAYS = 365;
  const rangeBetween = differenceInDays(endDate, startDate);
  if (rangeBetween < 0) return {
    valid: false,
    reason: 'Start date is ahead of end date'
  };
  if (rangeBetween > MAX_RANGE_IN_DAYS) return {
    valid: false,
    reason: `Date range is too big. Maximum is ${MAX_RANGE_IN_DAYS} days`
  };
  return {
    valid: true
  };
};
export const DateRangeForm = ({
  setRangeValidStatus
}) => {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  useEffect(() => {
    setRangeValidStatus(validateRange(values.startDate, values.endDate));
  }, [values]);
  return /*#__PURE__*/_jsxs(Box, {
    $display: "flex",
    "data-sentry-element": "Box",
    "data-sentry-component": "DateRangeForm",
    "data-sentry-source-file": "DateRangeForm.tsx",
    children: [/*#__PURE__*/_jsx(FormGroup, {
      $flex: "1",
      label: "From",
      htmlFor: "field-start-date",
      "data-sentry-element": "FormGroup",
      "data-sentry-source-file": "DateRangeForm.tsx",
      "data-sentry-element": "FormGroup",
      children: /*#__PURE__*/_jsx(AppDatePicker, {
        id: "field-start-date",
        value: values.startDate,
        onChange: date => {
          setFieldValue('startDate', date);
        },
        maxDate: values.endDate,
        "data-sentry-element": "AppDatePicker",
        "data-sentry-source-file": "DateRangeForm.tsx",
        "data-sentry-element": "AppDatePicker"
      })
    }), /*#__PURE__*/_jsx(Box, {
      $alignItems: "center",
      $boxSizing: "content-box",
      $display: "flex",
      $flex: "none",
      $height: "5sp",
      $justifyContent: "center",
      $pt: "3sp",
      $width: "6sp",
      as: "span",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "DateRangeForm.tsx",
      "data-sentry-element": "Box",
      children: "-"
    }), /*#__PURE__*/_jsx(FormGroup, {
      $flex: "1",
      label: "To",
      htmlFor: "field-end-date",
      "data-sentry-element": "FormGroup",
      "data-sentry-source-file": "DateRangeForm.tsx",
      "data-sentry-element": "FormGroup",
      children: /*#__PURE__*/_jsx(AppDatePicker, {
        id: "field-end-date",
        value: values.endDate,
        onChange: date => setFieldValue('endDate', date),
        maxDate: new Date(),
        "data-sentry-element": "AppDatePicker",
        "data-sentry-source-file": "DateRangeForm.tsx",
        "data-sentry-element": "AppDatePicker"
      })
    })]
  });
};